<template>
  <div>
    <div class="filesList">
      <div class="file" v-for="file in files" :key="file.index">
        <div>
          <i class="fad fa-file" />
          <!-- <img src="@/assets/icons/file.svg" alt="" /> -->
          <span v-if="file.name.length < 25">{{ file.name }}</span>
          <span v-else>{{ file.name.substring(0, 30) + ".." }}</span>
        </div>
        <div>
          <a :href="file.url" target="_blank" download class="download">download</a>
          <span class="click delete" @click="deleteFile(file)">Delete</span>
        </div>
      </div>
    </div>

    <button @click="triggerFileInput">Upload Bestand</button>
    <!-- Hidden input:file to trigger file selecter popup -->
    <input type="file" ref="fileInput" @change="onFileSelected" style="display:none;" />
  </div>
</template>

<script>
import store from "../../store"

export default {
  name: "UploadFileToOpdracht",
  props: { userId: String, files: Array },
  data() {
    return {
      fileName: "",
      file: null
    }
  },
  computed: {},
  methods: {
    deleteFile(file) {
      const payload = {
        userId: this.userId,
        fileUrl: file.url,
        fileName: file.name,
        files: this.files
      }
      store.dispatch("deleteFileFromStorageAndUser", payload)
    },
    triggerFileInput() {
      // Emulate click on input:file to open selector
      this.$refs.fileInput.click()
    },
    onFileSelected(event) {
      // Get selected file from input
      // triggers on: @change
      const file = event.target.files[0]
      // Check whether file has an extension
      if (file.name.lastIndexOf(".") <= 0) return alert("Please add a valid file! ")
      // Set name of selected file
      this.fileName = file.name
      // Set file in data to be ready for upload
      this.file = file
      this.triggerFileUpload()
    },
    triggerFileUpload() {
      // Check if file is selected
      if (!this.file) return alert("nope...")
      // Set payload for upload
      let payload = {
        userId: this.userId,
        fileName: this.fileName,
        file: this.file
      }
      // ! Trigger file upload via store
      // ? Create store function in new module
      store.dispatch("uploadFileToStorageAndUser", payload)
      // Leeg data
      this.fileName = ""
      this.file = null
    }
  }
}
</script>

<style scoped>
button {
  background-color: #3076ea;
  color: white;
  margin-top: 10px;
  font-size: 14px;
  padding: 7px 10px;
  border-radius: 5px;
  border: none;
  cursor: pointer;
}

.click {
  cursor: pointer;
}

.file {
  font-size: 0.9rem;
  border-radius: 0.5rem;
  padding: 10px;
  padding-left: 1rem;
  margin-top: 0.5rem;
  line-height: 1em;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #3076ea10;
}

.file div {
  display: flex;
  align-items: center;
}

a {
  padding: 0 10px;
  cursor: pointer;
}

i {
  display: flex;
  align-items: center;
  color: #3076ea;
  font-size: 16px;
  margin-right: 0.5rem;
}

.download,
.delete {
  background-color: #3076ea;
  color: white;
  margin-left: 0.5rem;
  padding: 0.5rem 0.6rem;
  border-radius: 0.3rem;
  font-weight: 500;
  display: flex;
  align-items: center;
  text-decoration: none;
  font-size: 0.8rem;
}

.delete {
  background-color: black;
}
</style>
